import { useNewestEvent } from "@/lib/api";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import DatePickerStyled from "../DatePickerStyled";
import { GenreSelector } from "../GenreSelector";
import { RegionSelector } from "../RegionSelector";
import { SurroundingSearchFilter } from "../SurroundingSearchFilter";

export default function EventFilterContainer({ filter, onChange }) {
  const { event: newestEvent } = useNewestEvent();
  const [selectedDate, setSelectedDate] = useState(filter.date);

  const handleInputChanged = (event) => {
    if (onChange && typeof onChange === "function") {
      const { name, value } = event.target;
      onChange(name, value);
    }
  };

  const handleDateChanged = (value) => {
    if (onChange && typeof onChange === "function") {
      setSelectedDate(value);
      onChange("date_start", value);
    }
  };

  const handleResetDate = () => {
    if (onChange && typeof onChange === "function") {
      setSelectedDate(null);
      onChange("date_start", null);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        sx={{ mb: 1, display: { xs: "none", md: "block" } }}
      >
        Filter
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box>
            <DatePickerStyled
              label="Beginn"
              disablePast={false}
              minDate={new Date("2024-01-01")}
              maxDate={newestEvent ? new Date(newestEvent.date_start) : null}
              onChange={handleDateChanged}
              value={selectedDate}
            />
            {selectedDate && (
              <Button
                variant="outlined"
                size="small"
                onClick={handleResetDate}
                sx={{
                  display: { xs: "block", lg: "none" },
                  p: 1,
                }}
                fullWidth
              >
                Beginn zurücksetzen
              </Button>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <GenreSelector
            label="Genre"
            placeholder="Alle Genres"
            onChange={handleInputChanged}
          />
        </Grid>
        <Grid item xs={12}>
          <SurroundingSearchFilter onChange={handleInputChanged} />
        </Grid>
        <Grid item xs={12}>
          <RegionSelector
            label="Region"
            placeholder="Alle Regionen"
            onChange={handleInputChanged}
          />
        </Grid>
      </Grid>
    </>
  );
}
